import styled, { css } from 'styled-components'
import { defaultProps } from 'recompose'

import BodyBase from './BodyBase'

export const body2Styles = css`
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: 0.25px;
`

const Body2 = styled(BodyBase)`
  ${body2Styles};
`

export default defaultProps({
  as: 'p',
})(Body2)
